import React from "react";
import { DownloadSimple, FilePdf } from "@phosphor-icons/react";
import { downloadCSV, printPDF } from "../../lib/exporters";

const ExportButtons = ({ title, filename, columns, rows, getRows, testidPrefix = "export" }) => {
  const [busy, setBusy] = React.useState(false);
  const disabled = busy || (!getRows && (!rows || rows.length === 0));
  const run = async (fn) => {
    if (!getRows) return fn(rows);
    setBusy(true);
    try { fn(await getRows()); } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-2">
      <button
        data-testid={`${testidPrefix}-csv`}
        disabled={disabled}
        onClick={() => run((r) => downloadCSV(filename, columns, r))}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-[rgba(42,28,21,0.18)] text-[#6E5022] hover:bg-[#2A1C15]/5 font-heading tracking-widest text-[0.75rem] uppercase disabled:opacity-30 disabled:cursor-not-allowed"
        title="Download as CSV"
      >
        <DownloadSimple size={14} weight="bold" /> CSV
      </button>
      <button
        data-testid={`${testidPrefix}-pdf`}
        disabled={disabled}
        onClick={() => { const w = window.open("", "_blank", "width=1200,height=800"); run((r) => printPDF(title, columns, r, w)); }}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-[rgba(42,28,21,0.18)] text-[#6E5022] hover:bg-[#2A1C15]/5 font-heading tracking-widest text-[0.75rem] uppercase disabled:opacity-30 disabled:cursor-not-allowed"
        title="Print / save as branded PDF"
      >
        <FilePdf size={14} weight="bold" /> PDF
      </button>
    </div>
  );
};

export default ExportButtons;
